import {
  convertPassouFalhouEnumToBoolean,
  convertSimNaoEnumToBoolean,
} from '@mchat-rf/consulta-seguimento/converter-consultaSeguimento'
import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { ConsultaSeguimentoPergunta12Model } from './model-consultaSeguimentoPergunta12'

export const convertConsultaSeguimentoPergunta12ToInput = (
  value: ConsultaSeguimentoPergunta12Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_12_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_12_EXEMPLOS?.MAQUINA_DE_LAVAR),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_12_EXEMPLOS?.CHORO_DE_BEBES),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_12_EXEMPLOS?.ASPIRADOR_DE_PO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_05,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_12_EXEMPLOS?.SECADOR_DE_CABELO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_06,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_12_EXEMPLOS?.TRANSITO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_07,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_12_EXEMPLOS?.GRITO_DE_BEBES),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_08,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_12_EXEMPLOS?.MUSICA_ALTA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_09,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_12_EXEMPLOS?.TOQUE_TELEFONE_CAMPAINHA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_10,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_12_EXEMPLOS?.BARULHO_DE_LIQUIDIFICADOR),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_11,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_12_EXEMPLOS?.LUGARES_BARULHENTOS),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_12,
      stResposta: convertSimNaoEnumToBoolean(value.OUTRO?.radioValue),
      outros: value.OUTRO?.textValue,
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_13,
      stResposta: convertSimNaoEnumToBoolean(
        value.PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU?.PASSOU?.TAMPA_OUVIDOS_CALMAMENTE
      ),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_14,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU?.PASSOU?.NAO_GOSTA_BARULHO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_15,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU?.FALHOU?.GRITA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_16,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU?.FALHOU?.CHORA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_17,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU?.FALHOU?.TAMPA_OUVIDOS),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_12_18,
      stResposta: convertPassouFalhouEnumToBoolean(value.PERGUNTA_12_FREQUENCIA),
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
